module.exports = __webpack_public_path__ + "img/blogs_purple.f0ca514f.png";